"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderHtmlReceipt = void 0;
class GetOrderHtmlReceipt {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.getOrderHtmlReceipt(request);
    }
}
exports.GetOrderHtmlReceipt = GetOrderHtmlReceipt;
